var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sankey-container" }, [
    _c("svg", { ref: "sankeyContainer", staticClass: "hide" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }